import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'core/client.service';
import { ClassificationValues } from '../common/classification-value';
import { SecurityService } from 'core/security.service';
import { SamplicityPermission } from 'dtp/common/permissions';
import { AuthService } from 'core/auth.service';
import { UserLogDto } from 'shared/service-clients/security';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'samplicity-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  private readonly adalLoginRequestKey = 'adal.login.request';
  pageSchema: object;
  clientIdParameter: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private clientService: ClientService,
    private authService: AuthService,
    private securityService: SecurityService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.tenantId) {
        this.clientService.changeClient(params.tenantId);
      }
      this.redirect();
    });
  }

  private redirectToErrorPage(): void {
    this.router.navigate(['/error']);
  }


  private redirectAfterTokenRefresh() {
    const redirectUrl = sessionStorage.getItem(this.adalLoginRequestKey);
    const selectedClientId = this.clientService.getClientId();
    if (redirectUrl) {
      sessionStorage.removeItem(this.adalLoginRequestKey);
      const redirectUrlArray = redirectUrl.split('#');
      if (redirectUrlArray) {
        const redirectRoute = redirectUrlArray[1];
        if (redirectRoute && redirectRoute !== '/') {
          console.log('Post-Token re-direct to ' + redirectRoute);
          const redirectRouteArray = redirectRoute.split('?');
          let queryParams = null;
          if (redirectRouteArray.length > 1) {
            queryParams = {};
            const redirectQueryParams = redirectRouteArray[1].split('&');
            for (const qp of redirectQueryParams) {
              const qpd = qp.split('=');
              queryParams[qpd[0]] = qpd[1];
            }
          }
          if (queryParams) {
            this.router.navigate([redirectRouteArray[0]], { queryParams: queryParams });
          } else {
            this.router.navigate([redirectRouteArray[0]]);
          }
        } else {
          this.redirect();
        }
      }
    } else {
      this.redirect();
    }
  }

  private hasRedirectUrl(): boolean {
    const redirectUrl = sessionStorage.getItem(this.adalLoginRequestKey);
    if (redirectUrl) {
      return true;
    } else {
      return false;
    }
  }

  // Used to redirect
  private redirect(): void {
    if (this.hasRedirectUrl()) {
      this.securityService.getUserAccess().then((ua) => {        
        this.redirectAfterTokenRefresh();        
          const userLogDto: UserLogDto = new UserLogDto({
            userId: ua.userId,
            userAgent: navigator.userAgent,
            logTime: new Date(),
            logTypeId: ClassificationValues.LogType.LOG_IN,
            terminalId: ''
          });
          this.securityService.logUserSession(userLogDto).subscribe();        
      });
    } else {
      this.securityService.getPermissions().then((permissions) => {
        if (permissions) {
          // Has permission to navigate through Nav Bar
          const navMapping = SamplicityPermission.NavMapping.find(function(nm) {
            return permissions.some(up => nm.Permission.toLowerCase() === up.toLowerCase());
          });
          if (navMapping) {
            const nmRoute = navMapping.Route;
            // Has View Client Details Permission
            if (permissions.some(up => up.toLowerCase() === SamplicityPermission.Client.ClientDetailView.toLowerCase())) {
              // Check if client has been activated
              this.clientService.getCurrentClient().subscribe(result => {
                if (result && result.tenantModules && result.tenantModules.length > 0) {
                  // tslint:disable-next-line:max-line-length
                  const dtpModule = result.tenantModules.find(x => x.moduleId.toLowerCase() === ClassificationValues.TENANT_MODULE_TYPE_DTP.toLowerCase());
                  if (dtpModule) {
                    // tslint:disable-next-line:max-line-length
                    if (dtpModule.tenantModuleStatusClassificationValueId.toLowerCase() === ClassificationValues.TENANT_MODULE_STATUS_NEW.toLowerCase()) {
                      const route = `/${result.tenantId}/admin/client/`;
                      console.log('navigating to route: ' + route);
                      this.router.navigate([route]);
                    } else {
                      const route = nmRoute.replace('{0}', result.tenantId);
                      console.log('navigating to route: ' + route);
                      this.router.navigate([route]);
                    }
                  } else {
                    this.redirectToErrorPage();
                  }
                } else {
                  this.redirectToErrorPage();
                }
              }, (e: any) => {
                console.log(e);
                this.redirectToErrorPage();
              });
            } else {
              const param = this.clientService.getClientId();
              const route = nmRoute.replace('{0}', param);

              console.log('navigating to route: ' + route);
              this.router.navigate([route]);
            }
          } else {
            this.redirectToErrorPage();
          }
        } else {
          this.redirectToErrorPage();
        }
      });
    }
  }
}
